import React from 'react';
import { Bell, Search, Menu, Wifi } from 'lucide-react';

const Header: React.FC = () => {
  const currentPrice = 2034.50;
  const priceChange = +12.34;
  const priceChangePercent = +0.61;

  return (
    <header className="win-glass border-b border-win-dark-border px-6 py-4">
      <div className="flex items-center justify-between">
        {/* Left Section */}
        <div className="flex items-center gap-6">
          <button className="lg:hidden p-2 rounded-3xl hover:bg-win-dark-surface-light transition-colors">
            <Menu className="w-5 h-5 text-win-dark-text" />
          </button>
          
          {/* Live Gold Price */}
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="text-sm text-win-dark-text-muted">Live Gold Price</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-2xl font-bold text-win-dark-text">
                ${currentPrice.toLocaleString()}
              </span>
              <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-sm font-medium ${
                priceChange >= 0 
                  ? 'bg-win-dark-success/20 text-green-400' 
                  : 'bg-win-dark-error/20 text-red-400'
              }`}>
                <span>{priceChange >= 0 ? '+' : ''}${priceChange}</span>
                <span>({priceChange >= 0 ? '+' : ''}{priceChangePercent}%)</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-4">
          {/* Search */}
          <div className="relative hidden md:block">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-win-dark-text-muted" />
            <input
              type="text"
              placeholder="Search trades, competitions..."
              className="win-input pl-10 pr-4 py-2 w-80"
            />
          </div>

          {/* Connection Status */}
          <div className="flex items-center gap-2 px-3 py-2 bg-win-dark-success/20 rounded-3xl">
            <Wifi className="w-4 h-4 text-green-400" />
            <span className="text-sm text-green-400 font-medium">Connected</span>
          </div>

          {/* Notifications */}
          <div className="relative">
            <button className="p-3 rounded-3xl hover:bg-win-dark-surface-light transition-colors relative">
              <Bell className="w-5 h-5 text-win-dark-text" />
              <div className="absolute -top-1 -right-1 w-5 h-5 bg-win-dark-error rounded-full flex items-center justify-center">
                <span className="text-xs text-white font-bold">3</span>
              </div>
            </button>
          </div>

          {/* User Avatar */}
          <button className="flex items-center gap-3 p-2 rounded-3xl hover:bg-win-dark-surface-light transition-colors">
            <div className="w-10 h-10 bg-gradient-to-br from-win-dark-accent to-blue-600 rounded-full flex items-center justify-center">
              <span className="text-white font-bold">JD</span>
            </div>
            <div className="hidden lg:block text-left">
              <p className="text-sm font-medium text-win-dark-text">John Doe</p>
              <p className="text-xs text-win-dark-text-muted">Gold Member</p>
            </div>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;